import { render, staticRenderFns } from "./editGoodsInfo.vue?vue&type=template&id=7c6c9602&scoped=true&"
import script from "./editGoodsInfo.vue?vue&type=script&lang=js&"
export * from "./editGoodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./editGoodsInfo.vue?vue&type=style&index=0&id=7c6c9602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6c9602",
  null
  
)

export default component.exports